import React from "react";

import { Fade } from "react-reveal";

import "./styles.css";

const stats = [
  {
    label: "Closing date",
    value: "July 24, 2026",
  },
  {
    label: "Estimated funding",
    value: "$36 million",
  },
  {
    label: "Expected awards",
    value: "55",
  },
  {
    label: "Award range",
    value: "$500,000-$950,000",
  },
];

const GrantAlignment = () => {
  return (
    <Fade bottom>
      <section id="grant-alignment" className="rural_grant_container">
        <div className="rural_grant_header">
          <span className="h2-sb text-white">
            Funding Opportunity: OVW FY 2026 Grant Program
          </span>
          <h1 className="h1-b text-white">
            Funding details and official resources
          </h1>
          <p className="h3-m text-white">
            The Office on Violence Against Women has released the FY 2026
            Domestic Violence, Dating Violence, Sexual Assault, and Stalking
            Grant Program. This program supports efforts by eligible campuses
            and universities to enhance safety and justice for victims in
            geographically dispersed communities.
          </p>
          <p className="h3-m text-white">
            For organizations pursuing funding to improve reporting,
            documentation, coordination, victim-service workflows, safety
            awareness, or program visibility, See It Send It may be a strong
            technology partner to consider as part of a broader grant-funded
            initiative.
          </p>
        </div>
        <div className="rural_grant_stat_grid">
          {stats.map((stat) => (
            <article className="rural_grant_stat" key={stat.label}>
              <span className="h4-r text-white">{stat.label}</span>
              <strong className="h2-sb text-white">{stat.value}</strong>
            </article>
          ))}
        </div>
        <div className="rural_grant_detail_grid">
          <article className="rural_grant_detail">
            <h2 className="h2-sb text-white">Eligibility summary</h2>
            <p className="h4-r text-white">
              Eligible applicants include campuses and universities in rural
              communities.
            </p>
          </article>
          <article className="rural_grant_detail">
            <h2 className="h2-sb text-white">Official resources</h2>
            <p className="h4-r text-white">
              Applicants should review the full OVW Notice of Funding
              Opportunity and Grants.gov listing to confirm eligibility,
              allowable activities, deadlines, and application instructions.
            </p>
            <div className="rural_grant_links">
              <a
                href="https://www.justice.gov/ovw/media/1443461/dl?inline"
                target="_blank"
                rel="noreferrer"
                className="h4-m rural_grant_link"
              >
                OVW FY 2026 Program NOFO
              </a>
              <a
                href="https://www.grants.gov/search-results-detail/362636"
                target="_blank"
                rel="noreferrer"
                className="h4-m rural_grant_link"
              >
                Grants.gov opportunity listing
              </a>
            </div>
          </article>
        </div>
      </section>
    </Fade>
  );
};

export default GrantAlignment;
